import React from 'react'
import PropTypes from 'prop-types'
import ProgressBar from '../elements/ProgressBar'
import globals from '../globals'
import UnlimitedBar from '../elements/UnlimitedBar'

const BarChartText = (props) => {
    return (
        <div className='bar-chart-wrapper'>
            <div className='row mb-2'>
                <div className='col-12 col-lg-8 mb-1 mb-lg-0'>
                    <span className='d-none d-lg-inline'>
                        <span className='bold'>{props.item.title}:</span> {props.item.usageDescription}
                    </span>
                    <span className='d-lg-none'>
                        <span className='bold'>{props.item.title}:</span>
                    </span>
                </div>
                <div className='col-12 col-lg-4 text-lg-right'>
                    <span className='d-none d-lg-inline'>{props.item.summaryText}</span>
                    <span className='d-lg-none'>{props.item.usageDescription} - {props.item.summaryText}</span>
                </div>
            </div>
            <div className='row d-none d-lg-flex'>
                <div className='col-12'>
                    <UnlimitedBar />
                </div>
            </div>
        </div>
    )
}

BarChartText.propTypes = {
    item: PropTypes.shape({
        title: PropTypes.string.isRequired,
        summaryText: PropTypes.string.isRequired,
        usageDescription: PropTypes.string.isRequired
    }).isRequired
}

export default BarChartText



// WEBPACK FOOTER //
// ./resources/js/components/BarChartText.js